// extracted by mini-css-extract-plugin
export var actionText = "_q7-4";
export var container = "_q7-0";
export var leftSection = "_q7-1";
export var rightSection = "_q7-2";
export var settingsButton = "_q7-6";
export var settingsIcon = "_q7-7";
export var shortcut = "_q7-5";
export var shortcutGroup = "_q7-3";